import { Component, Input, OnInit, forwardRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatPaginator } from '@angular/material';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import { Observable } from 'rxjs/Observable';

import { ContributorService } from './../../../services/contributor.service';
import { Contributor } from '../../../models/Contributor';

@Component({
  selector: 'app-contributor-search',
  templateUrl: './contributor-search.component.html',
  styleUrls: ['./contributor-search.component.css'],
  providers: [
    ContributorService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContributorSearchComponent),
      multi: true
    }
  ]
})
export class ContributorSearchComponent implements OnInit {
  stateCtrl: FormControl;
  public loading = false;
  @Input() required: boolean = false;
  contributors: Observable<any>;
  selected: Contributor;
  nomecompleto: string;

  q: string;
  total: number;
  cpage: number;
  psize: number = 20;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private contributorService: ContributorService) {
    this.stateCtrl = new FormControl();
  }

  onOptionSelected(e) {
    console.log(e.option.value)
    this.selected = e.option.value;
    if (this.selected) {
      this.nomecompleto = this.selected.nomecompleto;
          this.propagateChange(this.selected);
    }

  }

  onChange(e) {
    console.log('change', e)
  }

  // ngOnInit() {
  //   this.paginator.page.subscribe(e => {
  //        console.log(e);
  //        // console.log(this.cpage);
  //        // console.log(this.cpage != e.pageIndex);
  //        if (e ) {
  //          this.loading = true;
  //          this.cpage = e.pageIndex;
  //          this._search()
  //        }
  //      })
  //   this.stateCtrl.valueChanges
  //     .debounceTime(200)
  //     .subscribe(val => {
  //       let boo = (typeof (val) === 'string' || val instanceof String);
  //       // console.log('INIZIO autore change: ', val);
  //       // console.log('val string: ', (val instanceof String));
  //       // console.log('boo: ', boo);
  //       if (boo) {
  //         this.loading = true;
  //         this.contributors = this.contributorService.search(val)
  //           .map(result => {
  //             console.log(result)
  //             this.loading = false;
  //             this.selected = undefined;
  //             this.propagateChange(undefined);
  //             if (result.success) {
  //               return result.items;
  //             }
  //           })
  //       }
  //     })
  // }

  ngOnInit() {

    this.paginator.page.subscribe(e => {
      console.log(e);
      // console.log(this.cpage);
      // console.log(this.cpage != e.pageIndex);
      if (e) {
        this.loading = true;
        this.cpage = e.pageIndex;
        this._search()
      }
    })

    this.stateCtrl.valueChanges
      .debounceTime(200)
      .subscribe(val => {
        let boo = (typeof (val) === 'string' || val instanceof String);
        if (boo) {
          this.loading = true;
          this.q = val;
          this.cpage = 0;
          this._search()
        }
      })
  }

  _search() {
    let opt = {
      // q: this.q,
      filter: { jolly: this.q },
      pageSize: this.psize,
      pageNumber: this.cpage + 1
    }
    this.contributors = this.contributorService.search(opt)
      .map(result => {
        console.log(result)
        this.total = result.total_count;
        this.cpage = result.page - 1;
        this.psize = result.pageSize;
        this.loading = false;
        this.selected = undefined;


        // this.propagateChange(undefined);
        if (result.success) {
          return result.items;
        }
      })
  }

  displayFn(item) {
    return item ? item.nomecompleto : item;
  }

  private propagateChange = (_: any) => { };

  // nomecompleto: string
  public writeValue(obj: Contributor) {
    console.log('======= ************ writeValue', obj)
    if (obj) {
      this.nomecompleto = obj.nomecompleto;
    }
    // this.nomecompleto = nomecompleto;
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/contributor/contributor-search/contributor-search.component.ts